import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithReauth } from "@/core/api/baseQuery"
import type {
  SpamTestSettings,
  SpamTestSettingsPayload,
} from "@/types/entities/spamTestSettings"

export const spamTestSettingsApi = createApi({
  reducerPath: "spamTestSettingsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Spam Test Settings"],
  endpoints: (builder) => ({
    getSpamTestSettings: builder.query<SpamTestSettings, void>({
      query: () => ({
        method: "GET",
        url: "admin/spam-test-settings",
      }),
      transformResponse: ({ data }: { data: SpamTestSettings }) => data,
      providesTags: ["Spam Test Settings"],
    }),
    updateSpamTestSettings: builder.mutation<
      SpamTestSettings,
      SpamTestSettingsPayload
    >({
      query: (body) => ({
        method: "PATCH",
        url: "admin/spam-test-settings",
        body,
      }),
      invalidatesTags: ["Spam Test Settings"],
      transformResponse: ({ data }: { data: SpamTestSettings }) => data,
    }),
    resetSpamTestSettings: builder.mutation<SpamTestSettings, void>({
      query: () => ({
        method: "POST",
        url: "admin/spam-test-settings/reset",
      }),
      invalidatesTags: ["Spam Test Settings"],
      transformResponse: ({ data }: { data: SpamTestSettings }) => data,
    }),
    resetSpamTestSettingsRound: builder.mutation<SpamTestSettings, number>({
      query: (roundNumber) => ({
        method: "POST",
        url: `admin/spam-test-settings/reset/round/${roundNumber}`,
      }),
      invalidatesTags: ["Spam Test Settings"],
      transformResponse: ({ data }: { data: SpamTestSettings }) => data,
    }),
  }),
})

export const {
  useGetSpamTestSettingsQuery,
  useResetSpamTestSettingsMutation,
  useResetSpamTestSettingsRoundMutation,
  useUpdateSpamTestSettingsMutation,
} = spamTestSettingsApi
